// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"15fa8c5d","885":"323659ee"}[chunkId] + ".chunk.js";
};